// @flow
import gql from "graphql-tag"

export const paginationFragment = gql`
  fragment paginationFragment on PaginationPageInfoNumber {
    hasNextPage
    nextOffset
    totalCount
  }
`

export const locationFragment = gql`
  fragment locationFragment on Location {
    id
    name
  }
`



// WEBPACK FOOTER //
// ./src/data/app/graphql/fragments.js